import { IEmail } from 'types';
import { IAuditLog, IMrzData, IStudentConfig, IVisa } from '../../types';

export interface StudentState extends IVisa {
  config: IStudentConfig;
  auditLog: Array<IAuditLog>;
  mrzData: IMrzData | null;
  emails: Array<IEmail>;
}

export enum Q {
  LEGAL_ADVICE_DISCLAIMER = 'legalAdviseDisclaimer',
  INFO_PROCESSING = 'infoProcessing',
  EMAIL = 'email',
  GIVEN_NAME = 'givenName',
  SURNAME = 'surname',
  MIDDLE_NAME = 'middleName',
  HAS_OTHER_NAMES = 'hasOtherNames',
  OTHER_NAMES = 'otherNames',
  OTHER_NAME_SURNAME = 'otherNameSurname',
  OTHER_NAME_GIVEN_NAME = 'otherNameGivenName',
  OTHER_NAME_REASON = 'otherNameReason',
  DOB = 'dob',
  PHONE_NUMBER = 'phoneNumber',
  NATIONALITY = 'nationality',
  HAS_OTHER_NATIONALITY = 'hasOtherNationality',
  OTHER_NATIONALITIES = 'otherNationalities',
  OTHER_NATIONALITIES_IS_CURRENT = 'otherNationalitiesCurrent',
  GENDER = 'gender',
  ADDRESS = 'homeAddress',
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values -- deliberate alias for ADDRESS above, both are used across the codebase
  HOME_ADDRESS = 'homeAddress',
  POSTCODE = 'postCode',
  CITY = 'city',
  COUNTRY = 'country',
  BIRTH_COUNTRY = 'birthCountry',
  HAS_CRIMINAL_CONVICTIONS = 'hasCriminalConvictions',
  CRIMINAL_CONVICTIONS_REASON = 'criminalConvictionReason',
  STUDENT_NUMBER = 'studentNo',
  COURSES = 'courses',
  END_DATE = 'endDate',
  HAS_WORK_PLACEMENT = 'hasWorkPlacement',
  START_DATE = 'startDate',
  START_DATE_MANUAL = 'startDateManual',
  INTAKE_ID = 'intakeId',
  COURSE_LEVEL = 'courseLevel',
  COURSE_OFFER_EVIDENCE = 'offerEvidence',
  COURSE_LEVEL_OTHER = 'courseLevelOther',
  COURSE_NAME = 'courseName',
  COURSE_NAME_MANUAL = 'courseNameManual',
  CAH3_CODE = 'CAH3',
  CAH3_CODE_MANUAL = 'CAH3Manual',
  PASSPORT_STATUS = 'passportStatus',
  PASSPORT_NUMBER = 'passportNumber',
  PASSPORT_EXPIRY = 'passportExpiryDate',
  PASSPORT_EXPECTED = 'passportExpectedDate',
  AGENT = 'withAgent',
  SOMEONE_ELSE_NAME = 'someoneElseName',
  AGENT_NAME = 'agentName',
  AGENT_NOT_LISTED = 'agentNotListed',
  VISA_SUPPORT = 'visaSupport',
  APPLIED_FOR_EUSS = 'appliedForEUSS',
  GRANTED_EUSS_STATUS = 'grantedEUSSStatus',
  IS_COUNTRY_OF_NATIONALITY = 'applyingFromHomeCountry',
  LIVED_IN_UK_LAST_12_MONTHS = 'livedInUKLast12Months',
  COUNTRY_OF_VISA_APPLICATION = 'countryOfVisaApplication',
  REASON_WHY_NOT_COUNTRY_OF_NATIONALITY = 'otherCountryReason',
  HAS_ENGLISH_TEST = 'hasEnglishTest',
  ENGLISH_TEST_TYPE = 'englishTestType',
  ENGLISH_TEST_TYPE_OTHER = 'englishTestTypeOther',
  QUALIFICATION = 'qualification',
  QUALIFICATION_OTHER = 'qualificationOther',
  ENGLISH_TEST_NOT_REQD_REASON = 'englishTestNotReqdReason',
  ENGLISH_TEST_NOT_REQD_REASON_OTHER = 'englishTestNotReqdReasonOther',

  LAST_COURSE = 'lastCourse',
  LAST_COURSE_OTHER = 'lastCourseOther',
  LAST_COURSE_YEAR = 'lastCourseYear',
  HAS_OVERSEAS_TRAVEL = 'hasOverseasTravel',
  OVERSEAS_TRAVEL_TIMES = 'overseasTravelTimes',
  HAS_UK_TRAVEL = 'hasUkTravel',
  UK_TRAVEL_TIMES = 'ukTravelTimes',
  HAS_PREVIOUS_UK_STUDY = 'hasPreviousUkStudy',
  HAS_PREVIOUS_UK_STUDY_VISA = 'hasPreviousUkStudyVisa',
  PREVIOUS_UK_VISAS = 'previousUkStudyVisas',
  LAST_COURSE_LEVEL = 'lastCourseLevel',
  REASON_WHY_LOWER_OR_SAME_LEVEL = 'lowerOrSameLevelReason',
  UK_LEAVE_TO_REMAIN = 'hasLeaveToRemain',
  PREVIOUS_VISA_REJECTION = 'hasBorderRefusal',
  PREVIOUS_VISA_REJECTION_REASON = 'borderRefusalReason',
  PREVIOUS_UK_STUDY_TYPE = 'visaType',
  PREVIOUS_UK_STUDY_LEVEL_OF_STUDY = 'level',
  PREVIOUS_UK_STUDY_YEAR_OF_RECEIVED = 'year',
  PREVIOUS_UK_STUDY_IS_COURSE_COMPLETE = 'isComplete',
  PREVIOUS_UK_STUDY_REASON_WHY_NOT_COMPLETE_COURSE = 'incompleteReason',
  PREVIOUS_UK_STUDY_IS_INCOPLETE_RECORDED = 'isIncompleteRecorded',
  PREVIOUS_UK_STUDY_IS_VISA_SHORTENED = 'isVisaShortened',
  PREVIOUS_UK_STUDY_DATE_VISA_SHORTENED = 'shortenedDate',
  PREVIOUS_UK_VISA = 'visa',

  PREV_UK_OTHER_VISA = 'hasOtherUkVisas',
  PREV_UK_OTHER_VISAS = 'otherUkVisas',
  PREV_UK_OTHER_VISA_TYPE = 'prev_uk_other_visa_type',
  PREV_UK_OTHER_VISA_YEAR = 'prev_uk_other_visa_year',
  PREV_VISA_REFUSAL = 'hasUkVisaRefusals',
  PREV_VISA_REFUSALS = 'ukVisaRefusals',
  PREV_VISA_REFUSAL_TYPE = 'prev_visa_refusal_type',
  PREV_VISA_REFUSAL_YEAR = 'prev_visa_refusal_year',
  PREV_VISA_REFUSAL_DATE = 'prev_visa_refusal_date',
  PREV_NON_UK_VISA_REFUSAL = 'hasOtherVisaRefusals',
  PREV_NON_UK_VISA_REFUSALS = 'otherVisaRefusals',
  PREV_NON_UK_VISA_REFUSAL_COUNTRY = 'prev_non_uk_visa_country',
  PREV_NON_UK_VISA_REFUSAL_IS_STUDENT_VISA = 'prev_non_uk_visa_is_student_visa',
  PREV_NON_UK_VISA_REFUSAL_YEAR = 'prev_non_uk_visa_refusal_year',

  FAMILY_MEMBERS_TRAVELLING = 'hasDependents',
  SPOUSE_TRAVELLING = 'hasPartner',
  PARTNER_VISA_STATUS = 'partnerVisaStatus',
  CHILDREN_TRAVELLING = 'hasChildren',
  CHILDREN_TRAVELLING_NUMBER = 'childrenNum',
  COURSE_FEE_DEPOSIT_REQD = 'courseFeeDepositReqd',
  COURSE_FEE_DEPOSIT = 'courseFeeDeposit',
  COURSE_FEE_DEPOSIT_DATE = 'courseFeeDepositDate',
  COURSE_FEE_DEPOSIT_NOT_REQD_REASON = 'courseFeeDepositNotReqdReason',
  ACCOMMODATION_DEPOSIT_REQD = 'accomDepositReqd',
  ACCOMMODATION_DEPOSIT = 'accomDeposit',
  ACCOMMODATION_DEPOSIT_DATE = 'accomDepositDate',
  CAS_RECEIVED = 'casReceived',
  CONSENTS_1 = 'consents1',
  CONSENTS_2 = 'consents2',
  CONSENTS_3 = 'consents3',
  CONSENTS_4 = 'consents4',
  WHY_UK = 'whyUk',
  WHY_UK_OTHER = 'whyUkOther',
  SELECTED_COURSE_REASONS = 'selectedCourseReasons',
  SELECTED_COURSE_REASONS_OTHER = 'selectedCourseReasonsOther',
  SELECTED_UNI_REASONS = 'selectedUniReasons',
  SELECTED_UNI_REASONS_OTHER = 'selectedUniReasonsOther',
  UNI_CHOICE_REASON_1 = 'uniChoiceReason1',
  UNI_CHOICE_REASON_2 = 'uniChoiceReason2',
  UNI_CHOICE_REASON_3 = 'uniChoiceReason3',
  CAMPUS = 'campus',
  CAMPUS_MANUAL = 'campusManual',
  CAMPUS_PRE_CAS = 'campusPreCas',
  CONSIDER_OTHER_UNI = 'considerOtherUni',
  OTHER_UNI_1 = 'otherUni1',
  OTHER_UNI_2 = 'otherUni2',
  SELECTED_RESEARCH_METHODS = 'selectedResearchMethods',
  SELECTED_RESEARCH_METHODS_OTHER = 'selectedResearchMethodsOther',
  WHY_NOT_OTHER_UNI = 'whyNotOtherUni',
  CONSIDER_OTHER_COURSES = 'considerOtherCourses',
  CONSIDER_OTHER_COURSE = 'considerOtherCourse',
  WHY_NOT_CONSIDER_OTHER_COURSE = 'whyNotConsiderOtherCourse',
  COURSE_ALIGN_FUTURE_CAREER = 'courseAlignFutureCareer',
  COURSE_ALIGN_FUTURE_CAREER_OTHER = 'courseAlignFutureCareerOther',
  WORK_WHILE_STUDY = 'workWhileStudy',
  MAX_WORK_HOURS_PER_WEEK = 'maxWorkHoursPerWeek',
  WHY_WORK_WHILE_STUDY = 'whyWorkWhileStudy',
  WHY_WORK_WHILE_STUDY_OTHER = 'whyWorkWhileStudyOther',
  AFFORD_COURSE_AND_LIVING_WITHOUT_WORKING = 'affordCourseAndLivingWithoutWorking',
  AFFORD_COURSE_AND_LIVING_WITHOUT_WORKING_NO = 'affordCourseAndLivingWithoutWorkingNo',
  COMPLETE_DEGREE_WORK_COUNTRY = 'completeDegreeWorkCountry',
  EXPECTED_SALARY = 'expectedSalary',
  FURTHER_STUDY_IN_UK = 'furtherStudyInUk',
  FURTHER_STUDY_CAREER_PLANS = 'furtherStudyCareerPlans',
  LIVE_WHILE_STUDYING = 'liveWhileStudying',
  LIVE_WHILE_STUDYING_OTHER = 'liveWhileStudyingOther',
  EXPECTED_WEEKLY_RENT = 'expectedWeeklyRent',
  COMMUTE_PLAN = 'commutePlan',
  EXPECTED_LIVING_EXPENSES = 'expectedLivingExpenses',
  AWARE_OF_UK_VI_INTERVIEW = 'awareOfUKVIInterview',
  LIVING_COST = 'livingCost',
  COURSE_FEE = 'courseFee',
  INNER_LONDON = 'innerLondon',
  COURSE_NOT_LISTED = 'courseNotListedOrResearchStudent',
  OVERRIDE_MATURED_DATE = 'overrideMaturedDate',
  USE_WHATSAPP = 'useWhatsapp',
  WHATSAPP_OTHER_NUMBER = 'whatsAppPhoneNumber',
  HAS_PRE_SESSIONAL_COURSES = 'hasPresessionalCourse',
  PRE_SESSIONAL_COURSE_NAME = 'preSessionalCourseName',
  PRE_SESSIONAL_START_DATE = 'preSessionalStartDate',
  PRE_SESSIONAL_COURSE_FEE = 'preSessionalCourseFee',
  PRE_SESSIONAL_STUDY_MODE = 'preSessionalStudyMode',
  PRE_SESSIONAL_SEMESTER = 'preSessionalSemester',
  PRE_SESSIONAL_DURATION = 'preSessionalDuration',
}

export enum VQ {
  HAS_ADDITIONAL_PASSPORTS = 'hasAdditionalPassports',
  ADDITIONAL_PASSPORTS = 'additionalPassports',
  ADDITIONAL_PASSPORT_PASSPORT_NUMBER = 'additionalPassportDocNumber',
  ADDITIONAL_PASSPORT_PLACE_OF_ISSUE = 'additionalPassportPlaceOfIssue',
  ADDITIONAL_PASSPORT_ISSUING_AUTHORITY = 'additionalPassportIssuingAuthority',
  ADDITIONAL_PASSPORT_DATE_OF_ISSUE = 'additionalPassportIssueDate',
  ADDITIONAL_PASSPORT_DATE_OF_EXPIRY = 'additionalPassportExpiryDate',
  NON_HOME_COUNTRY_APP_DESC = 'nonHomeCountryApplicationDesc',
  HAS_OTHER_UK_VISAS = 'hasOtherUkVisas',
  OTHER_UK_VISAS = 'otherUkVisas',
  OTHER_UK_VISA_TYPE = 'otherUkVisaType',
  OTHER_UK_VISA_COUNTRY = 'otherUkVisaCountry',
  OTHER_UK_VISA_ISSUING_AUTH = 'otherUkVisaIssuingAuthority',
  OTHER_UK_VISA_DATE_OF_ISSUE = 'otherUkVisaIssueDate',
  OTHER_UK_VISA_DATE_OF_EXPIRY = 'otherUkVisaExpiryDate',
  TRIPS_TO_UK = 'tripsToUk',
  TRIPS_TO_UK_ARRIVAL_DATE = 'tripsToUkArrivalDate',
  TRIPS_TO_UK_DEPARTURE_DATE = 'tripsToUkDepartureDate',
  TRIPS_TO_UK_PURPOSE = 'tripsToUkPurpose',
  HAS_BEEN_TO_UK = 'hasBeenToUk',
  HAS_NI_NUMBER = 'hasNINumber',
  NI_NUMBER = 'niNumber',
  HAS_RECEIVED_MEDICAL_TREATMENT = 'hasReceivedMedicalTreatment',
  HAS_VOLUNTARILY_DEPARTED = 'hasVoluntarilyDeparted',
  HAS_EXCLUSION_ORDER = 'hasExclusionOrder',
  EXCLUSION_ORDERS = 'exclusionOrders',
  EXCLUSION_DATE = 'exclusionDate',
  EXCLUSION_REASON = 'exclusionReason',
  EXCLUSION_REFERENCE = 'exclusionReference',
  LEAVE_TO_REMAINS = 'leaveToRemains',
  LEAVE_TO_REMAIN_DATE = 'leaveToRemainDate',
  LEAVE_TO_REMAIN_TYPE = 'leaveToRemainType',
  LEAVE_TO_REMAIN_REFERENCE = 'leaveToRemainReference',
  BORDER_REFUSALS = 'borderRefusals',
  BORDER_REFUSAL_DATE = 'borderRefusalDate',
  BORDER_REFUSAL_AIRPORT = 'borderRefusalAirport',
  BORDER_REFUSAL_REASON = 'borderRefusalReason',
  BORDER_REFUSAL_REFERENCE = 'borderRefusalReference',
  HAS_BEEN_DEPORTED = 'hasBeenDeported',
  DEPORTATIONS = 'deportations',
  DEPORTED_COUNTRY = 'deportedCountry',
  DEPORTED_DATE = 'deportedRemovalDate',
  DEPORTED_AIRPORT = 'deportedAirport',
  DEPORTED_REASON = 'deportedReason',
  HAS_TRAVELLED = 'hasTravelled',
  TRAVEL_DETAILS = 'travelItems',
  TRAVEL_DETAILS_COUNTRY = 'travelCountry',
  TRAVEL_DETAILS_REASON = 'travelReason',
  TRAVEL_DETAILS_REASON_OTHER = 'travelReasonOther',
  TRAVEL_DETAILS_ENTRY_DATE = 'travelEntryDate',
  TRAVEL_DETAILS_EXIT_DATE = 'travelExitDate',

  NATIONALITY = 'nationality',
  FAMILY_NAME = 'familyName',
  GIVEN_NAME = 'givenName',
  DOB = 'dob',
  GENDER = 'gender',

  MARITAL_STATUS = 'maritalStatus',

  SPOUSE_NATIONALITY = 'spouseNationality',
  SPOUSE_FAMILY_NAME = 'spouseFamilyName',
  SPOUSE_GIVEN_NAME = 'spouseGivenName',
  SPOUSE_DOB = 'spouseDob',
  SPOUSE_LIVING_WITH = 'spouseLivingWith',
  SPOUSE_TRAVELLING_WITH = 'spouseTravellingWith',
  SPOUSE_UK_VISA = 'spouseUkVisa',
  SPOUSE_HAS_PASSPORT = 'spouseHasPassport',
  SPOUSE_PASSPORT_NUMBER = 'spousePassportNumber',
  SPOUSE_SAME_NATIONALITY = 'spouseSameNationality',

  FATHERS_PERSONAL_DETAILS = 'hasFathersPersonalDetails',

  FATHER_NATIONALITY = 'fatherNationality',
  FATHER_FAMILY_NAME = 'fatherFamilyName',
  FATHER_GIVEN_NAME = 'fatherGivenName',
  FATHER_DOB = 'fatherDob',
  FATHER_TRAVELLING_WITH = 'fatherTravellingWith',
  FATHER_UK_VISA = 'fatherUkVisa',
  FATHER_HAS_PASSPORT = 'fatherHasPassport',
  FATHER_PASSPORT_NUMBER = 'fatherPassportNumber',
  FATHER_SAME_NATIONALITY = 'fatherSameNationality',
  FATHER_PLACE_OF_BIRTH = 'fatherPlaceOfBirth',

  MOTHERS_PERSONAL_DETAILS = 'hasMothersPersonalDetails',

  MOTHER_NATIONALITY = 'motherNationality',
  MOTHER_FAMILY_NAME = 'motherFamilyName',
  MOTHER_GIVEN_NAME = 'motherGivenName',
  MOTHER_DOB = 'motherDob',
  MOTHER_TRAVELLING_WITH = 'motherTravellingWith',
  MOTHER_UK_VISA = 'motherUkVisa',
  MOTHER_HAS_PASSPORT = 'motherHasPassport',
  MOTHER_PASSPORT_NUMBER = 'motherPassportNumber',
  MOTHER_SAME_NATIONALITY = 'motherSameNationality',
  MOTHER_PLACE_OF_BIRTH = 'motherPlaceOfBirth',

  GUARDIANS_PERSONAL_DETAILS = 'hasGuardiansPersonalDetails',
  GUARDIAN_NATIONALITY = 'guardianNationality',
  GUARDIAN_FAMILY_NAME = 'guardianFamilyName',
  GUARDIAN_GIVEN_NAME = 'guardianGivenName',
  GUARDIAN_DOB = 'guardianDob',
  GUARDIAN_TRAVELLING_WITH = 'guardianTravellingWith',
  GUARDIAN_UK_VISA = 'guardianUkVisa',
  GUARDIAN_HAS_PASSPORT = 'guardianHasPassport',
  GUARDIAN_PASSPORT_NUMBER = 'guardianPassportNumber',
  GUARDIAN_SAME_NATIONALITY = 'guardianSameNationality',
  GUARDIAN_PLACE_OF_BIRTH = 'guardianPlaceOfBirth',

  CHILD_DETAILS = 'children',

  LIVING_WITH = 'livingWith',
  TRAVELLING_WITH = 'travellingWith',
  HAS_UK_VISA = 'ukVisa',
  HAS_PASSPORT = 'hasPassport',
  PASSPORT_NUMBER = 'passportNumber',
  SAME_NATIONALITY = 'sameNationality',
  PLACE_OF_BIRTH = 'placeOfBirth',
  HAS_DEPENDANT_CHILDREN = 'hasDependantChildren',
  CHILDREN_LIVING_WITH_YOU = 'childrenLivingWithYou',

  CONTACT_ADDRESS = 'contactAddress',
  CONTACT_CITY = 'contactCity',
  CONTACT_POSTCODE = 'contactPostcode',
  CONTACT_COUNTRY = 'contactCountry',
  CONTACT_NUMBER = 'contactNumber',
  TRAVELLING_WITH_OTHERS = 'travellingWithOthers',
  OTHER_TRAVELLERS = 'otherTravellers',
  RELATIONSHIP_TO_YOU = 'relationship',
  RELATIONSHIP_TO_YOU_OTHER = 'relationshipOther',
  ADULT_OR_CHILD = 'adultOrChild',
  HAS_ARRIVAL_DATE = 'hasArrivalDate',
  ARRIVAL_DATE = 'arrivalDate',
  LENGTH_IN_UK_INTENTION_DD = 'lengthOfStayDays',
  LENGTH_IN_UK_INTENTION_MM = 'lengthOfStayMonths',
  LENGTH_IN_UK_INTENTION_YY = 'lengthOfStayYears',
  UK_PRESENCE = 'ukPresence',
  UK_FAMILY = 'ukFamily',
  STAYING_WITH_FAMILY = 'stayingWithFamily',
  FAMILY_MEMBERS = 'familyMembers',
  FAMILY_CONTACT_ADDRESS = 'familyContactAddress',
  FAMILY_CONTACT_CITY = 'familyContactCity',
  FAMILY_CONTACT_POSTCODE = 'familyContactPostcode',
  FAMILY_CONTACT_COUNTRY = 'familyContactCountry',
  FAMILY_CONTACT_NUMBER = 'familyPhoneNumber',
  FAMILY_CONTACT_EMAIL = 'familyEmail',
  HAS_OTHER_CONTACT_ADDRESS = 'hasOtherContactAddress',
  OTHER_CONTACT_ADDRESS = 'otherContactAddress',
  OTHER_CONTACT_CITY = 'otherContactCity',
  OTHER_CONTACT_POSTCODE = 'otherContactPostcode',
  OTHER_CONTACT_COUNTRY = 'otherContactCountry',
  OTHER_CONTACT_NUMBER = 'otherPhoneNumber',
  HAS_CRIMINAL_CHARGES = 'hasCriminalCharges',
  HAS_TERRORISM_INVOLVEMENT = 'hasTerrorismInvolvement',
  HAS_TERRORISM_CONNECTION = 'hasTerrorismConnection',
  HAS_TERRORISM_JUSTIFIED = 'hasTerrorismJustified',
  HAS_WAR_CRIMES = 'hasWarCrimes',
  HAS_BAD_ACTIVITIES = 'hasBadActivities',
  LANGUAGE = 'language',
  HAS_RECEIVED_CAS = 'hasReceivedCas',
  STUDIES_CONFIRMATION_NUMBER = 'studiesConfirmationNumber',
  COURSE_END_DATE = 'courseEndDate',
  ALREADY_STARTED_STUDYING = 'alreadyStartedStudying',
  STUDY_ADDRESS = 'studyAddress',
  ASSESSED_BY_SPONSOR = 'assessedBySponsor',
  QUALIFICATION_AS_PROOF_OF_ENGLISH = 'qualificationAsProofOfEnglish',
  QUALIFICATION_AND_COUNTRY = 'qualificationAndCountry',
  APPLIED_THROUGH_UCAS = 'appliedThroughUCAS',
  UCAS_PIN = 'ucasPin',
  ACCOMMODATION_FEES_PAID = 'accommodationFeesPaid',
  ACCOMMODATION_FEES = 'accommodationFees',
  OTHER_FEEDBACK = 'otherFeedback',
  DIFFICULTIES_FEEDBACK = 'difficultiesFeedback',
  RESIDENTIAL_ADDRESS_START_DATE = 'residentialAddressStartDate',
  HOME_OWNERSHIP_STATUS = 'homeOwnershipStatus',
  HOME_OWNERSHIP_STATUS_OTHER = 'homeOwnershipStatusOther',
  HAS_DIFFERENT_CONTACT_DETAILS = 'hasDifferentContactDetails',
  DIFF_CONTACT_ADDRESS = 'diffContactAddress',
  DIFF_CONTACT_CITY = 'diffContactCity',
  DIFF_CONTACT_POSTCODE = 'diffContactPostcode',
  DIFF_CONTACT_COUNTRY = 'diffContactCountry',
}

export enum StudentActionTypes {
  OPEN_STUDENT = '@@student/OPEN_STUDENT',
  CLOSE_STUDENT = '@@student/CLOSE_STUDENT',
  CREATE_STUDENT_RECORD = '@@student/CREATE_STUDENT_RECORD',
  CREATE_STUDENT_RECORD_SUCCESS = '@@student/CREATE_STUDENT_RECORD_SUCCESS',
  CREATE_STUDENT_RECORD_FAILURE = '@@student/CREATE_STUDENT_RECORD_FAILURE',
  SAVE_PERSONAL_INFO = '@@student/SAVE_PERSONAL_INFO',
  SAVE_PERSONAL_INFO_SUCCESS = '@@student/SAVE_PERSONAL_INFO_SUCCESS',
  SAVE_PERSONAL_INFO_FAILURE = '@@student/SAVE_PERSONAL_INFO_FAILURE',
  SAVE_HISTORY = '@@student/SAVE_HISTORY',
  SAVE_HISTORY_SUCCESS = '@@student/SAVE_HISTORY_SUCCESS',
  SAVE_HISTORY_FAILURE = '@@student/SAVE_HISTORY_FAILURE',
  SAVE_CONSENTS = '@@student/SAVE_CONSENTS',
  SAVE_CONSENTS_SUCCESS = '@@student/SAVE_CONSENTS_SUCCESS',
  SAVE_CONSENTS_FAILURE = '@@student/SAVE_CONSENTS_FAILURE',
  SAVE_DOCUMENTS = '@@student/SAVE_DOCUMENTS',
  SAVE_DOCUMENTS_SUCCESS = '@@student/SAVE_DOCUMENTS_SUCCESS',
  SAVE_DOCUMENTS_FAILURE = '@@student/SAVE_DOCUMENTS_FAILURE',
  SAVE_FINANCE_SUCCESS = '@@student/SAVE_FINANCE_SUCCESS',
  SAVE_FINANCE_FAILURE = '@@student/SAVE_FINANCE_FAILURE',
  SAVE_VISA_PREP_FORM = '@@student/SAVE_VISA_PREP_FORM',
  SAVE_VISA_PREP_FORM_AND_GO_BACK = '@@student/SAVE_VISA_PREP_FORM_AND_GO_BACK',
  SAVE_VISA_PREP_FORM_SUCCESS = '@@student/SAVE_VISA_PREP_FORM_SUCCESS',
  SAVE_VISA_PREP_FORM_FAILURE = '@@student/SAVE_VISA_PREP_FORM_FAILURE',
  GET_STUDENT_RECORD = '@@student/GET_STUDENT_RECORD',
  GET_APPLICATION_RECORD = '@@student/GET_APPLICATION_RECORD',
  GET_STUDENT_RECORD_SUCCESS = '@@student/GET_STUDENT_RECORD_SUCCESS',
  GET_STUDENT_RECORD_FAILURE = '@@student/GET_STUDENT_RECORD_FAILURE',
  REGISTER_STUDENT_VIEW = '@@student/REGISTER_STUDENT_VIEW',
  GET_APPLICATION_RECORD_SUCCESS = '@@student/GET_APPLICATION_RECORD_SUCCESS',
  GET_APPLICATION_RECORD_FAILURE = '@@student/GET_APPLICATION_RECORD_FAILURE',
  GET_CONFIG_RECORD = '@@student/GET_CONFIG_RECORD',
  GET_CONFIG_RECORD_SUCCESS = '@@student/GET_CONFIG_RECORD_SUCCESS',
  GET_CONFIG_RECORD_FAILURE = '@@student/GET_CONFIG_RECORD_FAILURE',
  SAVE_FINANCE_DOCUMENTS = '@@student/SAVE_FINANCE_DOCUMENTS',
  SAVE_FINANCE_DOCUMENTS_SUCCESS = '@@student/SAVE_FINANCE_DOCUMENTS_SUCCESS',
  SAVE_FINANCE_DOCUMENTS_FAILURE = '@@student/SAVE_FINANCE_DOCUMENTS_FAILURE',
  GET_STUDENT_DOCS = '@@student/GET_STUDENT_DOCS',
  GET_STUDENT_DOCS_SUCCESS = '@@student/GET_STUDENT_DOCS_SUCCESS',
  GET_STUDENT_DOCS_FAILURE = '@@student/GET_STUDENT_DOCS_FAILURE',
  GET_STUDENT_AUDIT_LOGS = '@@student/GET_STUDENT_AUDIT_LOGS',
  GET_STUDENT_AUDIT_LOGS_SUCCESS = '@@student/GET_STUDENT_AUDIT_LOGS_SUCCESS',
  GET_STUDENT_AUDIT_LOGS_FAILURE = '@@student/GET_STUDENT_AUDIT_LOGS_FAILURE',
  GET_STUDENT_RECORDED_INTERVIEWS = '@@student/GET_STUDENT_RECORDED_INTERVIEWS',
  GET_STUDENT_RECORDED_INTERVIEWS_SUCCESS = '@@student/GET_STUDENT_RECORDED_INTERVIEWS_SUCCESS',
  GET_STUDENT_RECORDED_INTERVIEWS_FAILURE = '@@student/GET_STUDENT_RECORDED_INTERVIEWS_FAILURE',
  GET_STUDENT_CALENDLY_EVENTS = '@@student/GET_STUDENT_CALENDLY_EVENTS',
  GET_STUDENT_CALENDLY_EVENTS_SUCCESS = '@@student/GET_STUDENT_CALENDLY_EVENTS_SUCCESS',
  GET_STUDENT_CALENDLY_EVENTS_FAILURE = '@@student/GET_STUDENT_CALENDLY_EVENTS_FAILURE',
  GET_STUDENT_FIN_DOCS = '@@student/GET_STUDENT_FIN_DOCS',
  GET_STUDENT_FIN_DOCS_SUCCESS = '@@student/GET_STUDENT_FIN_DOCS_SUCCESS',
  GET_STUDENT_FIN_DOCS_FAILURE = '@@student/GET_STUDENT_FIN_DOCS_FAILURE',
  GET_STUDENT_MESSAGES = '@@student/GET_STUDENT_MESSAGES',
  GET_STUDENT_MESSAGES_SUCCESS = '@@student/GET_STUDENT_MESSAGES_SUCCESS',
  GET_STUDENT_MESSAGES_FAILURE = '@@student/GET_STUDENT_MESSAGES_FAILURE',
  GET_STUDENT_EMAILS = '@@student/GET_STUDENT_EMAIL',
  GET_STUDENT_EMAILS_SUCCESS = '@@student/GET_STUDENT_EMAILS_SUCCESS',
  GET_STUDENT_EMAILS_FAILURE = '@@student/GET_STUDENT_EMAILS_FAILURE',
  GET_STUDENT_FOLLOW_UP_DOCS = '@@student/GET_STUDENT_FOLLOW_UP_DOCS',
  GET_STUDENT_FOLLOW_UP_DOCS_SUCCESS = '@@student/GET_STUDENT_FOLLOW_UP_DOCS_SUCCESS',
  GET_STUDENT_FOLLOW_UP_DOCS_FAILURE = '@@student/GET_STUDENT_FOLLOW_UP_DOCS_FAILURE',

  SAVE_FOLLOW_UP_DOCUMENTS_SHARE_CODE = '@@student/SAVE_FOLLOW_UP_DOCUMENTS_SHARE_CODE',
  SAVE_FOLLOW_UP_DOCUMENTS = '@@student/SAVE_FOLLOW_UP_DOCUMENTS',
  SAVE_FOLLOW_UP_DOCUMENTS_SUCCESS = '@@student/SAVE_FOLLOW_UP_DOCUMENTS_SUCCESS',
  SAVE_FOLLOW_UP_DOCUMENTS_FAILURE = '@@student/SAVE_FOLLOW_UP_DOCUMENTS_FAILURE',
  OVERRIDE_MATURED_DATE = '@@student/OVERRIDE_MATURED_DATE',
  SAGA_COMPLETE = '@@student/SAGA_COMPLETE',
  SAVE_PRE_CAS_INTERVIEW = '@@student/SAVE_PRE_CAS_INTERVIEW',
  SAVE_PRE_CAS_INTERVIEW_SUCCESS = '@@student/SAVE_PRE_CAS_INTERVIEW_SUCCESS',
  SAVE_PRE_CAS_INTERVIEW_FAILURE = '@@student/SAVE_PRE_CAS_INTERVIEW_FAILURE',
  UPDATE_UNI_STUDENT_NUMBER = '@@student/UPDATE_UNI_STUDENT_NUMBER',
  UPDATE_OFFER_EVIDENCE = '@@student/UPDATE_OFFER_EVIDENCE',
  UPDATE_OFFER_EVIDENCE_SUCCESS = '@@student/UPDATE_OFFER_EVIDENCE_SUCCESS',
  UPDATE_OFFER_EVIDENCE_FAILURE = '@@student/UPDATE_OFFER_EVIDENCE_FAILURE',
  UPDATE_STATUS = '@@student/UPDATE_STATUS',
  UPDATE_STATUS_SUCCESS = '@@student/UPDATE_STATUS_SUCCESS',
  UPDATE_VISA_STATUS = '@@student/UPDATE_VISA_STATUS',
  UPDATE_VISA_STATUS_SUCCESS = '@@student/UPDATE_VISA_STATUS_SUCCESS',
  SAVE_MESSAGE = '@@student/SAVE_MESSAGE',
  SAVE_MESSAGE_SUCCESS = '@@student/SAVE_MESSAGE_SUCCESS',
  SAVE_MESSAGE_FAILURE = '@@student/SAVE_MESSAGE_FAILURE',
  NEW_MESSAGE = '@@student/NEW_MESSAGE',
  MARK_MESSAGES_READ = '@@student/MARK_MESSAGES_READ',
  MARK_MESSAGES_READ_SUCCESS = '@@student/MARK_MESSAGES_READ_SUCCESS',
  MARK_MESSAGES_READ_FAILURE = '@@student/MARK_MESSAGES_READ_FAILURE',
  MARK_MESSAGE_UNREAD = '@@student/MARK_MESSAGE_UNREAD',
  MARK_MESSAGE_UNREAD_SUCCESS = '@@student/MARK_MESSAGE_UNREAD_SUCCESS',
  MARK_MESSAGE_UNREAD_FAILURE = '@@student/MARK_MESSAGE_UNREAD_FAILURE',
  UPDATE_CORE = '@@student/UPDATE_CORE',
  UPDATE_STUDENT_DETAILS = '@@student/UPDATE_STUDENT_DETAILS',
  UPDATE_HISTORY = '@@student/UPDATE_HISTORY',
  UPDATE_FINANCE = '@@student/UPDATE_FINANCE',
  UPDATE_FINANCE_DOCUMENTS = '@@student/UPDATE_FINANCE_DOCUMENTS',
  UPDATE_FOLLOW_UP_DOCUMENTS = '@@student/UPDATE_FOLLOW_UP_DOCUMENTS',
  UPDATE_DOCUMENTS = '@@student/UPDATE_DOCUMENTS',
  DOWNLOAD_ATTACHMENTS = '@@student/DOWNLOAD_ATTACHMENTS',
  DOWNLOAD_ATTACHMENTS_FAILURE = '@@student/DOWNLOAD_ATTACHMENTS_FAILURE',
  DOWNLOAD_ATTACHMENTS_SUCCESS = '@@student/DOWNLOAD_ATTACHMENTS_SUCCESS',
  STUDENT_GO_BACK = '@@student/STUDENT_GO_BACK',

  SAVE_DEPOSIT = '@@student/SAVE_DEPOSIT',

  CREATE_ORGANISATION_SPONSOR = '@@student/CREATE_ORGANISATION_SPONSOR',
  UPDATE_ORGANISATION_SPONSOR = '@@student/UPDATE_ORGANISATION_SPONSOR',
  REMOVE_ORGANISATION_SPONSOR = '@@student/REMOVE_ORGANISATION_SPONSOR',
  REMOVE_ORGANISATION_REGION = '@@student/REMOVE_ORGANISATION_REGION',

  CREATE_EDUCATION_SPONSOR = '@@student/CREATE_EDUCATION_SPONSOR',
  UPDATE_EDUCATION_SPONSOR = '@@student/UPDATE_EDUCATION_SPONSOR',
  REMOVE_EDUCATION_SPONSOR = '@@student/REMOVE_EDUCATION_SPONSOR',
  REMOVE_EDUCATION_REGION = '@@student/REMOVE_EDUCATION_REGION',

  CREATE_SCHOLARSHIP_SPONSOR = '@@student/CREATE_SCHOLARSHIP_SPONSOR',
  UPDATE_SCHOLARSHIP_SPONSOR = '@@student/UPDATE_SCHOLARSHIP_SPONSOR',
  BULK_UPDATE_SCHOLARSHIP_SPONSOR = '@@student/BULK_UPDATE_SCHOLARSHIP_SPONSOR',
  REMOVE_SCHOLARSHIP_SPONSOR = '@@student/REMOVE_SCHOLARSHIP_SPONSOR',
  REMOVE_SCHOLARSHIP_REGION = '@@student/REMOVE_SCHOLARSHIP_REGION',

  CREATE_FAMILY_SPONSOR = '@@student/CREATE_FAMILY_SPONSOR',
  UPDATE_FAMILY_SPONSOR = '@@student/UPDATE_FAMILY_SPONSOR',
  REMOVE_FAMILY_SPONSOR = '@@student/REMOVE_FAMILY_SPONSOR',
  REMOVE_FAMILY_REGION = '@@student/REMOVE_FAMILY_REGION',

  CREATE_OTHER_SPONSOR = '@@student/CREATE_OTHER_SPONSOR',
  UPDATE_OTHER_SPONSOR = '@@student/UPDATE_OTHER_SPONSOR',
  REMOVE_OTHER_SPONSOR = '@@student/REMOVE_OTHER_SPONSOR',
  REMOVE_OTHER_REGION = '@@student/REMOVE_OTHER_REGION',

  UPDATE_CONFLICT = '@@student/UPDATE_CONFLICT',
  UPDATE_CONFLICT_SUCCESS = '@@student/UPDATE_CONFLICT_SUCCESS',
  UPDATE_CONFLICT_FAILURE = '@@student/UPDATE_CONFLICT_FAILURE',

  APPROVE_AGENT_SECTION = '@@student/APPROVE_AGENT_SECTION',
  APPROVE_AGENT_SECTION_FAILURE = '@@student/APPROVE_AGENT_SECTION_FAILURE',

  SAVE_AGENT_DETAILS = '@@student/SAVE_AGENT_DETAILS',
  SAVE_AGENT_DETAILS_FAILURE = '@@student/SAVE_AGENT_DETAILS_FAILURE',

  UPDATE_RISKS_REQUEST = '@@student/UPDATE_RISKS',
  UPDATE_RISKS_SUCCESS = '@@student/UPDATE_RISKS_SUCCESS',
  UPDATE_RISKS_FAILURE = '@@student/UPDATE_RISKS_FAILURE',

  DELETE_STUDENT = '@@student/DELETE_STUDENT',
  DELETE_STUDENT_SUCCESS = '@@student/DELETE_STUDENT_SUCCESS',
  DELETE_STUDENT_FAILURE = '@@student/DELETE_STUDENT_FAILURE',
  MARK_ACTIVE = '@@student/MARK_ACTIVE',
  REVOKE_STUDENT_ACCESS = '@@student/REVOKE_STUDENT_ACCESS',
  REMOVE_IMPORT_HASH = '@@student/REMOVE_IMPORT_HASH',
  REMOVE_IMPORT_HASH_SUCCESS = '@@student/REMOVE_IMPORT_HASH_SUCCESS',
  REMOVE_IMPORT_HASH_FAILURE = '@@student/REMOVE_IMPORT_HASH_FAILURE',
  CHANGE_STUDENT_NO = '@@student/CHANGE_STUDENT_NO',
  CHANGE_STUDENT_NO_SUCCESS = '@@student/CHANGE_STUDENT_NO_SUCCESS',
  CHANGE_STUDENT_NO_FAILURE = '@@student/CHANGE_STUDENT_NO_FAILURE',

  UPDATE_SUMMARY = '@@student/UPDATE_SUMMARY',

  DELETE_FILE = '@@student/DELETE_FILE',

  DELETE_DOCUMENT_FILE = '@@student/DELETE_DOCUMENT_FILE',
  DELETE_DOCUMENT_FILE_SUCCESS = '@@student/DELETE_DOCUMENT_FILE_SUCCESS',
  DELETE_DOCUMENT_FILE_FAILURE = '@@student/DELETE_DOCUMENT_FILE_FAILURE',
  DELETE_FINANCE_FILE = '@@student/DELETE_FINANCE_FILE',
  DELETE_FINANCE_FILE_SUCCESS = '@@student/DELETE_FINANCE_FILE_SUCCESS',
  DELETE_FINANCE_FILE_FAILURE = '@@student/DELETE_FINANCE_FILE_FAILURE',
  DELETE_FOLLOW_UP_FILE = '@@student/DELETE_FOLLOW_UP_FILE',
  DELETE_FOLLOW_UP_FILE_SUCCESS = '@@student/DELETE_FOLLOW_UP_FILE_SUCCESS',
  DELETE_FOLLOW_UP_FILE_FAILURE = '@@student/DELETE_FOLLOW_UP_FILE_FAILURE',
  DELETE_INTERVIEW_FILE = '@@student/DELETE_INTERVIEW_FILE',
  DELETE_INTERVIEW_FILE_SUCCESS = '@@student/DELETE_INTERVIEW_FILE_SUCCESS',
  DELETE_INTERVIEW_FILE_FAILURE = '@@student/DELETE_INTERVIEW_FILE_FAILURE',
  DELETE_RECORDED_INTERVIEW_FILE = '@@student/DELETE_RECORDED_INTERVIEW_FILE',
  DELETE_RECORDED_INTERVIEW_FILE_SUCCESS = '@@student/DELETE_RECORDED_INTERVIEW_FILE_SUCCESS',
  DELETE_RECORDED_INTERVIEW_FILE_FAILURE = '@@student/DELETE_RECORDED_INTERVIEW_FILE_FAILURE',

  SAVE_INTERVIEW_DOCUMENTS = '@@student/SAVE_INTERVIEW_DOCUMENTS',
  SAVE_INTERVIEW_DOCUMENTS_SUCCESS = '@@student/SAVE_INTERVIEW_DOCUMENTS_SUCCESS',
  SAVE_INTERVIEW_DOCUMENTS_FAILURE = '@@student/SAVE_INTERVIEW_DOCUMENTS_FAILURE',
  SAVE_RECORDED_INTERVIEW_DOCUMENTS = '@@student/SAVE_RECORDED_INTERVIEW_DOCUMENTS',
  SAVE_RECORDED_INTERVIEW_DOCUMENTS_SUCCESS = '@@student/SAVE_RECORDED_INTERVIEW_DOCUMENTS_SUCCESS',
  SAVE_RECORDED_INTERVIEW_DOCUMENTS_FAILURE = '@@student/SAVE_RECORDED_INTERVIEW_DOCUMENTS_FAILURE',

  REQUEST_RECORDED_INTERVIEW = '@@student/offer/REQUEST_RECORDED_INTERVIEW',
  REQUEST_RECORDED_INTERVIEW_SUCCESS = '@@student/offer/REQUEST_RECORDED_INTERVIEW_SUCCESS',
  REQUEST_RECORDED_INTERVIEW_FAILURE = '@@student/offer/REQUEST_RECORDED_INTERVIEW_FAILURE',

  REQUEST_SCHEDULED_INTERVIEW = '@@student/offer/REQUEST_SCHEDULED_INTERVIEW',
  CANCEL_SCHEDULED_INTERVIEW = '@@student/offer/CANCEL_SCHEDULED_INTERVIEW',
  FAIL_SCHEDULED_INTERVIEW = '@@student/offer/FAIL_SCHEDULED_INTERVIEW',
  RESIT_SCHEDULED_INTERVIEW = '@@student/offer/RESIT_SCHEDULED_INTERVIEW',
  PASS_SCHEDULED_INTERVIEW = '@@student/offer/PASS_SCHEDULED_INTERVIEW',
  TOGGLE_SCHEDULED_INTERVIEW_SUCCESS = '@@student/offer/TOGGLE_SCHEDULED_INTERVIEW_SUCCESS',
  TOGGLE_SCHEDULED_INTERVIEW_FAILURE = '@@student/offer/TOGGLE_SCHEDULED_INTERVIEW_FAILURE',

  FAIL_RECORDED_INTERVIEW = '@@student/offer/FAIL_RECORDED_INTERVIEW',
  RESIT_RECORDED_INTERVIEW = '@@student/offer/RESIT_RECORDED_INTERVIEW',
  PASS_RECORDED_INTERVIEW = '@@student/offer/PASS_RECORDED_INTERVIEW',
  TOGGLE_RECORDED_INTERVIEW_SUCCESS = '@@student/offer/TOGGLE_RECORDED_INTERVIEW_SUCCESS',
  TOGGLE_RECORDED_INTERVIEW_FAILURE = '@@student/offer/TOGGLE_RECORDED_INTERVIEW_FAILURE',
  CANCEL_RECORDED_INTERVIEW = '@@student/offer/CANCEL_RECORDED_INTERVIEW',
  CANCEL_RECORDED_INTERVIEW_SUCCESS = '@@student/offer/CANCEL_RECORDED_INTERVIEW_SUCCESS',
  CANCEL_RECORDED_INTERVIEW_FAILURE = '@@student/offer/CANCEL_RECORDED_INTERVIEW_FAILURE',

  UPDATE_CALENDLY_EVENT_WS = '@@student/UPDATE_CALENDLY_EVENT_WS',
  UPDATE_RECORDED_INTERVIEW_DOC = '@@student/UPDATE_RECORDED_INTERVIEW_DOC',
  CLEAR_STATE = '@@student/CLEAR_STATE',
  STUDENT_WEBSOCKET_CHANGE = '@@student/STUDENT_WEBSOCKET_CHANGE',
}
